import React from 'react';
import { Link } from 'react-router-dom';

const TerminiCondizioni = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-16">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white rounded-lg shadow-sm p-8 md:p-12">
          <h1 className="text-4xl font-bold text-slate-900 mb-4">Termini e Condizioni</h1>
          <p className="text-slate-600 mb-8"><strong>Ultimo aggiornamento:</strong> 25/09/2026</p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Chi siamo</h2>
            <p className="text-slate-700 mb-2">Edilservice 2.0 S.R.L.</p>
            <p className="text-slate-700 mb-2">P.IVA: 08848480722</p>
            <p className="text-slate-700 mb-2">Sede legale: Strada Comunale Mezzane</p>
            <p className="text-slate-700 mb-4">Email: <a href="mailto:edilserviceduepuntozerosrl@gmail.com" className="text-orange-600 hover:underline">edilserviceduepuntozerosrl@gmail.com</a></p>
            <p className="text-slate-700">Operiamo esclusivamente sul territorio italiano.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Come funziona il sito</h2>
            <p className="text-slate-700 mb-4">Il sito consente di sfogliare il catalogo prodotti e di inserire articoli in un carrello per inviarci una richiesta di preventivo/ordine. Compilando il modulo con nome, cognome ed email, e confermando il carrello, i tuoi dati e la lista degli articoli richiesti vengono inviati via email al nostro tecnico.</p>
            <p className="text-slate-700"><strong>Importante:</strong> l'invio della richiesta dal sito non costituisce un contratto di vendita né un ordine vincolante, e non comporta alcun pagamento online. Il sito non elabora né conserva dati di pagamento. Dopo aver ricevuto la tua richiesta, ti contatteremo telefonicamente per confermare disponibilità dei prodotti, prezzo definitivo, modalità di pagamento e di consegna o ritiro. Il contratto si considera concluso solo dopo questa conferma telefonica (o comunque diretta) tra le parti.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Informazioni sui prodotti</h2>
            <p className="text-slate-700">Le immagini, descrizioni e prezzi indicativi presenti sul sito hanno scopo illustrativo. Ci riserviamo di confermare o aggiornare prezzi, disponibilità e caratteristiche dei prodotti al momento del contatto telefonico, anche in base a variazioni di mercato o di fornitura.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Prezzi</h2>
            <p className="text-slate-700">I prezzi eventualmente mostrati sul sito sono indicativi e non vincolanti fino a conferma telefonica. Il prezzo definitivo viene comunicato e concordato durante il contatto telefonico successivo all'invio della richiesta.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Modalità di pagamento</h2>
            <p className="text-slate-700">Il sito non gestisce pagamenti online. Le modalità di pagamento vengono concordate direttamente con il cliente al telefono, successivamente all'invio della richiesta dal carrello.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Diritto di recesso</h2>
            <p className="text-slate-700">Poiché il sito non conclude vendite a distanza (il contratto si perfeziona solo dopo la conferma telefonica diretta tra le parti, e non tramite acquisto automatico online), le modalità di recesso ed eventuale reso verranno comunicate e concordate direttamente con il cliente al momento della conferma dell'ordine, nel rispetto della normativa applicabile ai consumatori.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Limitazione di responsabilità</h2>
            <p className="text-slate-700">Ci impegniamo a mantenere le informazioni sul sito accurate e aggiornate, ma non garantiamo l'assenza di errori o refusi. In caso di discrepanza tra quanto indicato sul sito e quanto confermato telefonicamente, prevale quanto concordato direttamente con il cliente.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Proprietà intellettuale</h2>
            <p className="text-slate-700">Contenuti, immagini, testi e loghi presenti sul sito sono di proprietà di Edilservice 2.0 S.R.L. o utilizzati con relativa autorizzazione, e non possono essere riprodotti senza previo consenso scritto.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Legge applicabile</h2>
            <p className="text-slate-700">I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia sarà competente il foro del consumatore, salvo diversa previsione inderogabile di legge.</p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-slate-800 mb-4">Contatti</h2>
            <p className="text-slate-700">Per qualsiasi domanda su questi Termini, scrivici a <a href="mailto:edilserviceduepuntozerosrl@gmail.com" className="text-orange-600 hover:underline">edilserviceduepuntozerosrl@gmail.com</a>.</p>
          </section>

          <div className="mt-12 pt-8 border-t border-slate-200">
            <Link to="/" className="text-orange-600 hover:underline font-medium">← Torna alla Home</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TerminiCondizioni;
